// extracted by mini-css-extract-plugin
export default {"Tag":"PickUpType_Tag__YTA0Z"};